<template>
  <md-dialog :md-active.sync="showDialog" @md-closed="closeDialog" class="contact-us">
    <div class="contact-us__wrap">
      <div class="contact-us__title text_x_large"> {{ i18n.contact_title() }}</div>
      <div class="contact-us__text text_description text_large">{{ i18n.contact_text() }}</div>
      <form @submit.prevent="submitForm"
            class="contact-us__form form"
            novalidate>
        <div class="form__element text_medium">
          <input-field
                 id="contact_us-name"
                 class="form__element-input"
                 v-model="contact_name"
                 v-validate.continues="'required|max:40'"
                 :errorMessage="errorMessage(i18n.contact_name())"
                 :label="i18n.contact_name()"
                 :name="i18n.contact_name()"
                 />
        </div>
        <div class="form__element text_medium">
          <input-field
                 id="contact_us-email"
                 class="form__element-input"
                 v-model="contact_email"
                 v-validate.continues="'required|email|max:80'"
                 :errorMessage="errorMessage(i18n.contact_email())"
                 :label="i18n.contact_email()"
                 :name="i18n.contact_email()"
                 />
        </div>
        <div class="form__element text_medium">
          <input-field
            id="contact_us-theme"
            class="form__element-input"
            v-model="contact_theme"
            v-validate.continues="'required|max:50'"
            :errorMessage="errorMessage(i18n.contact_theme())"
            :label="i18n.contact_theme()"
            :name="i18n.contact_theme()"
          />
        </div>
        <div class="form__element text_medium">
          <textarea-field
            id="contact_us-textarea"
            class="form__element-input"
            v-model="contact_text"
            v-validate.continues="'required|max:800'"
            :label="i18n.contact_message()"
            :name="i18n.contact_message()"
            type="text"
          />
          <span v-for="error in errors.collect(i18n.contact_message())" class="form__error">{{ error }}</span>
        </div>
        <div v-if="sendError" class="form__error">{{ i18n.contact_send_error() }}</div>
        <div class="btn-wrap space-between margin-top">
          <md-button class="btn md-primary" type="submit" :disabled="!isFormValid">{{ i18n.contact_send() }}</md-button>
          <md-button class="btn md-primary" @click="closeDialog">{{ i18n.lbl_close() }}</md-button>
        </div>
      </form>
    </div>
  </md-dialog>
</template>

<script>
  import formMixin from '@com/mixins/form.mixin'

  import config from '@conf'
  import { i18n } from '@js/i18n'
  import { vuexTypes } from '@vuex/types'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { mapGetters } from 'vuex'
  import axios from 'tokend-js-sdk/node_modules/axios'

  export default {
    mixins: [formMixin],
    name: 'contact-us',
    props: {
      showDialog: { type: Boolean, default: false },
      sendError: { type: Boolean, default: false }
    },
    data () {
      return {
        contact_email: '',
        name: '',
        contact_theme: '',
        contact_message: '',
        i18n,
        msgSuccess: i18n.contact_success()
      }
    },
    mounted () {
      this.contact_email = this.userEmail ? this.userEmail : ''
    },
    computed: {
      ...mapGetters([
        vuexTypes.userEmail
      ]),
      isFormValid () {
        return Object.keys(this.fields).every(field => this.fields[field].valid)
      }
    },
    methods: {
      closeDialog () {
        this.$emit('close-dialog', false)
      },
      submitForm () {
        let url = config.HORIZON_SERVER + '/notifications/contact'
        let message = {
          name: this.contact_name,
          email: this.contact_email,
          subject: this.contact_theme,
          message: this.contact_text,
          type: 'platform'
        }
        let snackConfig = {
          msg: this.msgSuccess,
          type: 'success'
        }

        axios.post(url, message).then(res => {
          EventDispatcher.dispatchShowSnackbarEvent(snackConfig)
          this.closeDialog()
        })
          .catch(error => {
            this.sendError = true
            console.log(error)
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .contact-us {
    min-width: 500px;

    @include respond-to($small) {
      min-width: 100%;
      max-width: 100%;
    }

    &__title,
    &__text {
      margin-bottom: 14px;
      color: $col-text;
    }

    & .form {
      &__element {
        position: relative;
        margin-bottom: 20px;
        &:last-child {
          margin: 10px 0 0;
        }
      }
      &__send-error,
      &__error {
        font-size: 12px;
        color: $col-invalid;
      }

      &__error {
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/navigation/contact-us_popup/contact-us.vue